import React from 'react'

import {useRouterProvider} from '../context/RouterContext'

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string
  children?: React.ReactNode | undefined
}

/**
 * Link component that will automatically use the active router from RouterProvider for client-side navigation
 * @param props - anchor props
 * @param props.to - destination href
 * @param props.onClick - onClick callback
 * @param props.children
 * @returns
 */
export const RouterAgnosticLink = ({
  to,
  onClick,
  children,
  ...anchorProps
}: Props) => {
  const {push} = useRouterProvider()
  const handleClick: Props['onClick'] = event => {
    onClick?.(event)
    if (anchorProps.target === '_blank' || event.defaultPrevented) return
    event.preventDefault()
    to && push(to)
  }
  return (
    <a {...anchorProps} href={to} onClick={handleClick}>
      {children}
    </a>
  )
}
